import * as React from 'react'
import styled from 'styled-components'

import ThumbnailList from 'containers/ThumbnailList'

const MainContainer = styled.div`
  margin: 10px;
`

export default () => (
  <MainContainer>
    <ThumbnailList />
  </MainContainer>
)



// WEBPACK FOOTER //
// ./src/containers/Main/index.tsx